export enum NotificationType {
  Information,
  ActionRequired,
  Important
}

export enum NotificationActionType {
  NoAction
}

export enum NotificationConstantType {
  LastLogin,
  LicenseExpired,
  NewInformation,
  PaymentInformation,
  ChangeLimit,
  Survey,
  Notif,
  Order,
  PoolOrder,
  VoucherSuccess,
  VoucherFailed,
  OpenProposalSuccess
}

export class Notification {
  id: string;
  title: string;
  body: string;
  created_date: Date;
  is_read: boolean;
  type: NotificationType;
  action_type: NotificationActionType;
  constant_type: NotificationConstantType;
  data: string;
  read_date: Date;
  string_created_date: string;

}
